export default {
  badgesContainer: {
    width: 940,
    display: "grid",
    gridGap: 10,
    gridTemplateColumns: "465px 465px",
  },
};
